'use client'

import React, { useEffect, useState } from 'react'
import { Menu, MenuItem } from '@mui/material'
import { THEME_COLORS } from '../../theme/colors'

interface Props {
  contextMenu: { mouseX: number; mouseY: number } | null
  handleCloseContextMenu: () => void
  handleCopyFromMenu: () => void
  clickedHeaderIndex: number | null
  onHideColumns?: (ids: string[]) => void
  handleHideColumn: () => void
  clickedRowIndex: number | null
  onHideRows?: (rows: number[]) => void
  handleHideRow: () => void
}

export default function ContextualMenu({
  contextMenu,
  handleCloseContextMenu,
  handleCopyFromMenu,
  clickedHeaderIndex,
  onHideColumns,
  handleHideColumn,
  clickedRowIndex,
  onHideRows,
  handleHideRow,
}: Props) {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia('(prefers-color-scheme: dark)')
    setIsDark(mql.matches)
    const handler = () => setIsDark(mql.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  const colors = isDark ? {
    paper: THEME_COLORS.dark.paper,
    text: THEME_COLORS.dark.text,
    divider: THEME_COLORS.dark.divider,
    hover: THEME_COLORS.dark.hover,
    shadow: '0 10px 24px rgba(0,0,0,0.28)',
  } : {
    paper: THEME_COLORS.light.paper,
    text: THEME_COLORS.light.text,
    divider: THEME_COLORS.light.divider,
    hover: THEME_COLORS.light.hover,
    shadow: '0 10px 24px rgba(18,124,243,0.08)',
  }

  return (
    <Menu
      open={contextMenu !== null}
      onClose={handleCloseContextMenu}
      anchorReference="anchorPosition"
      anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
      PaperProps={{
        sx: {
          bgcolor: colors.paper,
          color: colors.text,
          border: `1px solid ${colors.divider}`,
          boxShadow: colors.shadow,
        },
      }}
      MenuListProps={{
        sx: {
          py: 0.5,
          '& .MuiMenuItem-root': {
            fontSize: 13,
            '&:hover': { bgcolor: colors.hover },
          },
        },
      }}
    >
      <MenuItem onClick={handleCopyFromMenu}>Copy</MenuItem>
      {onHideColumns && clickedHeaderIndex != null && (
        <MenuItem onClick={handleHideColumn}>Hide column</MenuItem>
      )}
      {onHideRows && clickedRowIndex != null && (
        <MenuItem onClick={handleHideRow}>Hide row</MenuItem>
      )}
    </Menu>
  )
}
